import React, { useEffect, useState } from "react";
import { enter, mailText, not_approved, passwordText, user_not_exists, welcome } from "../texts/login";
import ErrorAlert from "../common/errorAlert";
import SecondaryAlert from "../common/secondaryAlert";
import { useLoginUser } from "../hook/use_login_user";
import "./Login.css";
import LoginInput from "./loginInput";
import { useDispatch } from "react-redux";

const Login = () => {
  const [password, setPassword] = useState("");
  const [mail, setMail] = useState("");
  const { loading, response, checkUserExists } = useLoginUser({ password, mail });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'RESET_APP' });
  }, []);

  return (
    <div className="login-container">
      <img src="logo.png" />
      <h1>{welcome}</h1>
      <form onSubmit={checkUserExists} className="login-form">
        <LoginInput setValue={setMail} value={mail} type={"email"} text={mailText} />
        <LoginInput setValue={setPassword} value={password} type={"password"} text={passwordText} />
        <button className="btn btn-primary" disabled={loading}>
          {loading ? <span className="spinner-border spinner-border-sm" role="status" /> : enter}
        </button>
        {response === 2 && <ErrorAlert msg={not_approved} />}
        {response === 3 && <SecondaryAlert msg={user_not_exists} />}
      </form>
    </div>
  );
};

export default Login;
